export default __webpack_public_path__ + "static/media/setting_blue.7fc6180a.svg";